import {
  EConcurrencyType,
  EGeoType,
  IGetBetsPositionRequest,
} from '../../../../repositories/auction/v1/get-bets-position';
import { ECategory } from '../../../../repositories/monolith-python/entities/offer/OfferSchema';
import { ICoordinates, IGeoAddressItem, IOfferState } from '../../../../types/reducers/offer';
import { EServiceId } from '../../../../types/reducers/publishTerms';
import { getBetPositionServices } from './getBetPositionServices';
import { IPackage } from '../../../../reducers/v2/publicationPackages/types';

interface IGetBetPositionParams {
  serviceIds: EServiceId[];
  packages: IPackage[];
  offer: IOfferState;
  childLocation: IGeoAddressItem | null;
  coordinates: ICoordinates;
  currentBet: number;
  isAuctionEnabled: boolean;
  isPromotionPackageSelected: boolean;
  extraData: object;
}

export function getBetPositionParams(params: IGetBetPositionParams): IGetBetsPositionRequest {
  const {
    serviceIds,
    packages,
    offer: { category, id, bargainTerms },
    childLocation,
    coordinates: { lat, lng },
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
    extraData,
  } = params;

  const geoId = childLocation?.id || undefined;
  const geoType = (childLocation?.type as unknown as EGeoType) || undefined;

  const packageIds = packages.map(item => item.serviceId);

  const services = getBetPositionServices({
    serviceIds,
    packageIds,
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
  });

  return {
    concurrencyType: EConcurrencyType.Local,
    announcementId: id,
    price: bargainTerms.price,
    geoId,
    geoType,
    category: category as ECategory,
    services,
    lat,
    lon: lng,
    extraData,
  };
}
